<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col class="d-flex flex-wrap mb-4" cols="12">
          <div>
            <v-hover v-slot="{ hover }">
              <v-card
                :elevation="hover ? 14 : 8"
                class="ma-2 pa-3 rounded-lg d-flex align-center justify-center pattern"
                :class="{ selected: selectedDesign === '' }"
                height="60"
                width="60"
                @click="chooseDesign('')"
              >
                <v-icon color="#222" size="32">mdi-cancel</v-icon>
              </v-card>
            </v-hover>
          </div>
          <div v-for="(item, index) in designObject" :key="index">
            <v-hover v-slot="{ hover }">
              <v-card
                :elevation="hover ? 14 : 8"
                class="ma-2 pa-3 rounded-lg d-flex align-center justify-center pattern"
                height="60"
                width="60"
                :class="{ selected: selectedDesign === item.value }"
                @click="chooseDesign(item.value)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  :class="{ filterwhite: selectedDesign === item.value }"
                  class="rounded-0 pattern"
                  viewBox="0 0 16 16"
                  width="40"
                  height="40"
                  fill="currentColor"
                  v-html="item.img.path"
                ></svg>
              </v-card>
            </v-hover>
          </div>
        </v-col>

        <!-- Borders Color Control -->
        <v-col class="pa-2" cols="12">
          <v-card class="pa-3 marker-color-section" outlined>
            <div class="text-subtitle-2 mb-3 marker-corner-title">
              <v-icon class="mr-2" color="warning">mdi-square-outline</v-icon>
              رنگ حاشیه‌ها
            </div>

            <!-- Switch for different border colors -->
            <v-row no-gutters class="mb-3">
              <v-col cols="12">
                <v-switch
                  v-model="options.different_borders_color"
                  label="رنگ‌های جداگانه برای هر حاشیه"
                  color="primary"
                  @change="handleDifferentBordersChange"
                />
                <!-- Debug info -->
                <div class="text-caption grey--text mt-1">
                  حالت فعلی:
                  {{
                    options.different_borders_color
                      ? "رنگ‌های جداگانه"
                      : "رنگ یکسان"
                  }}
                </div>
              </v-col>
            </v-row>

            <!-- Single Border Color Mode -->
            <v-row v-if="!options.different_borders_color" no-gutters>
              <v-col cols="12" md="6" class="pa-1">
                <color-picker
                  v-model="options.cornersSquareOptions.color"
                  label="رنگ همه حاشیه‌ها"
                  @input="$emit('update', true)"
                />
              </v-col>
            </v-row>

            <!-- Individual Border Colors Mode -->
            <v-row v-if="options.different_borders_color" no-gutters>
              <v-col cols="12" md="4" class="pa-1">
                <color-picker
                  v-model="options.marker_top_right_outline"
                  label="حاشیه بالا راست"
                  @input="$emit('update', true)"
                />
              </v-col>
              <v-col cols="12" md="4" class="pa-1">
                <color-picker
                  v-model="options.marker_out_color"
                  label="حاشیه بالا چپ"
                  @input="$emit('update', true)"
                />
              </v-col>
              <v-col cols="12" md="4" class="pa-1">
                <color-picker
                  v-model="options.marker_bottom_left_outline"
                  label="حاشیه پایین چپ"
                  @input="$emit('update', true)"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import ColorPicker from "../../components/colorPicker";

export default {
  name: "qrCodeSquareAdv",

  components: { ColorPicker },

  props: {
    value: Object,
    color: Array,
    designObject: Array,
  },

  data: () => ({
    selectedDesign: null,
    helpData: [],
    serviceName: "Qrland",
    componentName: "qrCodeSquareadv",

    // bgSwitch: false, // Disabled - borders only support single colors
    // designObject: [
    //   { value: "square", img: "/media/markOut/default.svg" },
    //   { value: "dot", img: "/media/markOut/circle.svg" },
    //   { value: "extra-rounded", img: "/media/markOut/rounded.svg" },
    //   { value: "circle", img: "/media/markOut/circle.svg" },
    //   { value: "default", img: "/media/markOut/default.svg" },
    //   { value: "drop", img: "/media/markOut/drop.svg" },
    //   { value: "dropeye", img: "/media/markOut/dropeye.svg" },
    //   { value: "dropeyeleaf", img: "/media/markOut/dropeyeleaf.svg" },
    //   { value: "dropeyeleft", img: "/media/markOut/dropeyeleft.svg" },
    //   { value: "dropeyerightt", img: "/media/markOut/dropeyerightt.svg" },
    //   { value: "drop_in", img: "/media/markOut/drop_in.svg" },
    //   { value: "flower", img: "/media/markOut/flower.svg" },
    //   { value: "flower_in", img: "/media/markOut/flower_in.svg" },
    //   { value: "flurry", img: "/media/markOut/flurry.svg" },
    //   { value: "leaf", img: "/media/markOut/leaf.svg" },
    //   { value: "rounded", img: "/media/markOut/rounded.svg" },
    //   { value: "sdoz", img: "/media/markOut/sdoz.svg" },
    //   { value: "squarecircle", img: "/media/markOut/squarecircle.svg" },
    // ],
    // rotation: 0, // Disabled - borders only support single colors
  }),

  mounted() {
    // Initialize border color properties if they don't exist
    if (typeof this.options.different_borders_color === "undefined") {
      this.options.different_borders_color = false;
    }
    if (!this.options.marker_out_color) {
      this.options.marker_out_color = "#000000";
    }
    if (!this.options.marker_top_right_outline) {
      this.options.marker_top_right_outline =
        this.options.marker_out_color || "#000000";
    }
    if (!this.options.marker_out_color) {
      this.options.marker_out_color =
        this.options.marker_out_color || "#000000";
    }
    if (!this.options.marker_bottom_left_outline) {
      this.options.marker_bottom_left_outline =
        this.options.marker_out_color || "#000000";
    }

    // Ensure synchronization
    if (!this.options.different_borders_color) {
      this.options.marker_top_right_outline = this.options.marker_out_color;
      this.options.marker_out_color = this.options.marker_out_color;
      this.options.marker_bottom_left_outline = this.options.marker_out_color;
    }

    // Set initial selected design
    if (
      this.options.cornersSquareOptions &&
      this.options.cornersSquareOptions.type
    ) {
      this.selectedDesign = this.options.cornersSquareOptions.type;
    }
  },

  computed: {
    options: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    // computedRotation: { // Disabled - borders only support single colors
    //   get() {
    //     return this.rotation;
    //   },
    //   set(val) {
    //     this.rotation = val;
    //     this.options.cornersSquareOptions.gradient.rotation =
    //       (val * Math.PI) / 180;
    //     this.$emit("update", true);
    //   },
    // },
  },

  watch: {
    "options.cornersSquareOptions.color": {
      handler(newVal) {
        if (!this.options.different_borders_color && newVal) {
          this.options.marker_top_right_outline = newVal;
          this.options.marker_out_color = newVal;
          this.options.marker_bottom_left_outline = newVal;
        }
      },
      immediate: false,
    },
    // Sync individual colors when single color changes
    "options.marker_out_color": {
      handler(newVal) {
        if (!this.options.different_borders_color && newVal) {
          // Update all individual colors when in single mode
          this.options.marker_top_right_outline = newVal;
          this.options.marker_out_color = newVal;
          this.options.marker_bottom_left_outline = newVal;
        }
      },
      immediate: false,
    },
  },

  methods: {
    chooseDesign(value) {
      this.selectedDesign = value;
      this.options.cornersSquareOptions.type = value;
      this.$emit("update", true); // Force update
    },
    handleDifferentBordersChange() {
      if (this.options.different_borders_color) {
        const baseColor = this.options.cornersSquareOptions.color || "#000000";

        if (!this.options.marker_top_right_outline)
          this.options.marker_top_right_outline = baseColor;

        if (!this.options.marker_out_color)
          this.options.marker_out_color = baseColor;

        if (!this.options.marker_bottom_left_outline)
          this.options.marker_bottom_left_outline = baseColor;
      } else {
        const finalColor = this.options.cornersSquareOptions.color || "#000000";

        this.options.cornersSquareOptions.color = finalColor;
        this.options.marker_top_right_outline = finalColor;
        this.options.marker_out_color = finalColor;
        this.options.marker_bottom_left_outline = finalColor;
      }

      this.$emit("update", true);
    },
  },
};
</script>

<style scoped>
.pattern:hover {
  border: 1px solid #413199;
  border-radius: 6px;
  background-color: #413199;
  box-shadow: 0 -8px 6px rgba(25, 25, 26, 0.2),
    0px 8px 6px rgba(25, 25, 26, 0.2);
}

.pattern.selected {
  border: 1px solid #001554;
  border-radius: 6px;
  background-color: #001554;
  box-shadow: 0 10px 15px #00155423, 0px -10px 15px #00155423;
}

/* Marker color section styling */
.marker-color-section {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fafafa;
  transition: all 0.3s ease;
}

.marker-color-section:hover {
  border-color: #bb86fc;
  box-shadow: 0 2px 8px rgba(187, 134, 252, 0.1);
}

.marker-corner-title {
  font-weight: 500;
  color: #424242;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.marker-color-picker {
  margin-bottom: 8px;
}

/* Icon styling */
.marker-corner-title .v-icon {
  opacity: 0.8;
}

.marker-corner-title .v-icon--color-warning {
  color: #ff9800 !important;
}

/* Radio button styling */
.v-radio-group {
  margin-bottom: 16px;
}

.v-radio {
  margin-right: 16px;
}
</style>
